// NPM Dependencies
import React from 'react';
import { useDispatch } from 'react-redux';

// Styles
import { ClickText } from 'commonStyles';

// Components
import Button from 'common/Button/Button';

// Constants
import { ADOBE_EVENT_VALUES, APPLICATION_CONSTANTS } from 'AppConstants';

// Redux Actions
import { modifyBooking } from 'reduxStore/actions/manageRequestBookingActions';

// Utils
import { pushManageBookingsClick } from 'UtilityComponents/manageRequestBookingUtils';

const Action = ({ url, type, value, bookingId }) => {
	const dispatch = useDispatch();

	/**
	 * @function redirectWithAccess
	 *
	 * @description - Redirects to the given URL
	 */
	const redirectWithAccess = () => {
		pushManageBookingsClick(ADOBE_EVENT_VALUES.MANAGE_BOOKING.PENDING_REQUEST_VIEW_DETAILS);
		window.open(url);
	};

	const modifyBookingData = () => (
		pushManageBookingsClick(ADOBE_EVENT_VALUES.MANAGE_BOOKING.ALL_BOOKINGS_MODIFY),
		dispatch(modifyBooking(bookingId))
	);

	return value ? (
		type === APPLICATION_CONSTANTS.BTN_TYPE.CLICKTEXT ?
			<ClickText onClick={modifyBookingData}>
				{value}
			</ClickText> :
			<Button
				padding='12px 10px'
				btnTxt={value}
				btnType='Flat'
				btnName='Secondary'
				btnShadow
				btnWidth='120px'
				btnFont='14px'
				handleClick={redirectWithAccess}
			/>

	) : null;
};

export default Action;
